<template>
    <div class="sort-box" @click="click">
        <span>Sort by:</span>
        <p class="item" :class="openSort ? 'active' : ''">
            <span>{{param}}</span>
            <icon-base width="11" height="7" viewBox="0 0 11 7"><icon-arrow-down/></icon-base>
        </p>
    </div>
</template>

<script>

import IconBase from "../common/IconBase";
import IconArrowDown from "../common/icons/IconArrowDonw";

export default {
    name: 'sort-box',

    components: {
        IconArrowDown,
        IconBase
    },

    props: {
        param: {
            type: String
        },
        open: {
            type: Boolean
        }
    },

    watch : {
        open: function (newVal) {
            this.openSort = newVal;
        }
    },

    data() {
        return {
            filterParam: '',
            openSort: false
        }
    },

    methods: {
        click() {
            this.openSort = !this.openSort;
            this.$emit('sortClick')
        }
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
